
export default function CoverageMap() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-brand-red font-semibold text-sm uppercase tracking-widest mb-3">
            Explore Our Reach
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-brand-navy mb-4">
            Florida Coverage Map
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Our service teams are strategically located across Florida to provide fast, reliable energy solutions to your doorstep.
          </p>
        </div>

        <div className="bg-brand-cream rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="w-full h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3584948.7741!2d-83.5!3d27.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c1766591562abf%3A0xf72e13d35bc74ed0!2sFlorida!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="United States Home Solutions Florida coverage map"
              aria-label="Interactive map showing our Florida service coverage areas"
            ></iframe>
          </div>
          <div className="p-6 flex flex-wrap items-center justify-center gap-8">
            <div className="flex items-center gap-2">
              <span className="w-4 h-4 rounded-full bg-brand-red"></span>
              <span className="text-sm text-gray-600 font-medium">Full Service Areas</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-4 h-4 rounded-full bg-brand-gold"></span>
              <span className="text-sm text-gray-600 font-medium">Expanding Soon</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-4 h-4 rounded-full border-2 border-gray-400"></span>
              <span className="text-sm text-gray-600 font-medium">Future Coverage</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
